import React from 'react';
import { useLocation } from 'react-router-dom';
import ImpersonationBanner from './layout/ImpersonationBanner';

import './AppWrapper.scss';

interface AppWrapperProps {
  children: React.ReactNode;
}

const AppWrapper: React.FC<AppWrapperProps> = ({ children }) => {
  const location = useLocation();
  // Normalise a trailing slash before matching: the password-reset email links to
  // `/reset-password/?token=…` (with the slash), and an exact `===` check would miss
  // it — dropping the auth single-column layout so the form renders collapsed.
  const path = location.pathname.replace(/\/+$/, '') || '/';

  return (
    <div
      className={`app
        ${path === '/signin' ? 'signin' : ''}
        ${path === '/forgot-password' ? 'forgot-password' : ''}
        ${path === '/reset-password' ? 'reset-password' : ''}
        ${path === '/registration/create-account' ? 'create-account' : ''}
        ${path === '/registration/account-created' ? 'account-created' : ''}
        ${path === '/registration/verify-email' ? 'verify-email' : ''}
        ${path === '/registration/confirmation-thank-you' ? 'confirmation-thank-you' : ''}
      `}
    >
      {children}
      {/*
        Here, and not in either chrome. The router has two layout branches with
        separate chrome — `AdminShell` for the console and the inline
        Logo/SideMenu/Header block for the user's app — so a banner hung off one
        of them is missing from the other, which is exactly the half an admin is
        in when they lose track of an impersonation. It renders nothing unless
        `impersonatedUsername` is set, so the auth pages above are unaffected.
      */}
      <ImpersonationBanner />
    </div>
  );
};

export default AppWrapper;